import { createFileRoute } from '@tanstack/react-router'
import { Logos } from '@/features/lab/Logos'

export const Route = createFileRoute('/_app/app/lab/logos')({
  staticData: { crumb: { label: 'Logos' } },
  component: Logos,
})
